import React from "react";
import { StyleSheet, View } from "react-native";
import RenderHtml from "react-native-render-html";
import LottieView from "lottie-react-native";
import RotatingCoin from "../assets/anim/rotating-coin.json";

const iconList = {
  coin: RotatingCoin,
};
const defaultText =
  "<p>इस ऑर्डर डिलीवरी पर पाएं <span>₹10</span> अतिरिक्त कमीशन !</p>";
const defaultIcon = "coin";
const defaultType = "REGULAR";

const stripTypeEnum = {
  regular: "REGULAR",
  bordered: "BORDERED",
  error: "ERROR",
};

function MetaStrip({
  text = defaultText,
  icon = defaultIcon,
  type = defaultType,
  smallStrip = false,
  extraStyling,
}) {
  const htmlTagStyles = {
    p: {
      textAlign: "center",
      fontWeight: "bold",
      color: "#000000",
      fontSize: 14,
      marginRight: 6,
    },
    span: {
      color: "#00AB59",
      fontWeight: "bold",
    },
  };
  const backgroundColor =
    type === stripTypeEnum.bordered
      ? "transparent"
      : type === stripTypeEnum.error
        ? "rgba(255,0,0,0.6)"
        : "#E5F7EE";
  return (
    <View
      style={[
        {
          backgroundColor,
          borderWidth: type === stripTypeEnum.bordered ? 1 : 0,
          borderStyle: "solid",
          borderColor:
            type === stripTypeEnum.bordered
              ? "rgba(0, 171, 89, 0.50)"
              : "transparent",
          paddingHorizontal: smallStrip ? 4 : 8,
          ...extraStyling,
        },
        styles.containerStyle,
      ]}
    >
      <LottieView
        source={iconList[icon]}
        autoPlay
        loop
        style={{
          height: smallStrip ? 42 : 48,
          width: smallStrip ? 42 : 48,
        }}
      />
      <View>
        <RenderHtml html={text} tagsStyles={htmlTagStyles} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  containerStyle: {
    borderRadius: 6,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 8,
  },
});

export default MetaStrip;
